import { zodResolver } from '@hookform/resolvers/zod';
import { Mapping } from 'api/MappingsAPI';
import { FieldType } from 'modules/domains';
import { ReactNode } from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import { z } from 'zod';

const createSchema = () => {
  return z.object({
    description: z.string().max(100, 'Description must be 100 characters or less'),
    fieldName: z
      .string()
      .min(1, 'Field is required')
      .max(100, 'Field name must be 100 characters or less'),
    fieldType: z.nativeEnum(FieldType),
    sampleValue: z.string().max(100, 'Sample value must be 100 characters or less'),
  });
};

type EditFieldFormProviderProps = {
  children: ReactNode;
  /** Field provided when editing, to get current value(s) */
  field?: Mapping;
};

export const EditFieldFormProvider = ({
  children,
  field = {} as Mapping,
}: EditFieldFormProviderProps) => {
  const schema = createSchema();
  const {
    description = '',
    fieldName = '',
    fieldType = FieldType.STRING,
    sampleValue = '',
  } = field;

  const defaultValues = {
    description,
    fieldName,
    fieldType,
    sampleValue,
  };

  const methods = useForm({
    defaultValues,
    mode: 'onSubmit',
    resolver: zodResolver(schema),
    reValidateMode: 'onChange',
  });

  return <FormProvider {...methods}>{children}</FormProvider>;
};
